import { useState, useEffect } from 'react'
import { useZustand } from './useZustand'

/**
 * Custom hook to extract and manage additional contexts from URL query parameters
 * Reads ?addcontext=context1&addcontext=context2 and saves to Zustand store
 * @returns {Array<string>} Array of additional context names
 */
export const useAdditionalContexts = () => {
    const [addContextParams, setAddContextParams] = useState([])
    const setAdditionalContexts = useZustand(state => state.setAdditionalContexts)
    const additionalContexts = useZustand(state => state.additionalContexts)

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const queryParams = new URLSearchParams(window.location.search)
            const contexts = queryParams.getAll('addcontext')
            setAddContextParams(contexts)
            // Save to Zustand store for global access
            setAdditionalContexts(contexts)
        }
    }, [setAdditionalContexts])

    return addContextParams.length > 0 ? addContextParams : additionalContexts
}
